// extracted by mini-css-extract-plugin
module.exports = {"div":"Header_div__1g61_","title":"Header_title__3_fub","subtitle":"Header_subtitle__3B6mZ","div2":"Header_div2__WCAe1","title2":"Header_title2__1sGca"};